import { promises as fs } from 'node:fs';
import getConfig from 'next/config.js';
import messages from './messages.mjs';

const defaultMessages = Object.fromEntries(
  Object.entries(messages)
    .map(([key, { defaultMessage }]) => [key, defaultMessage]),
);

export const addDefaultMessages = (localeMessages) => Object.fromEntries(
  Object.entries(defaultMessages)
    .map(([key, value]) => [key, localeMessages[key] || value]),
);

const loadMessages = async (locale) => JSON.parse(
  await fs.readFile((`./lang/${locale}.json`)),
);

const { assetPrefix } = {
  ...getConfig(),
  ...typeof process === 'undefined' ? {} : {
    assetPrefix: process.env.ASSET_PREFIX,
  },
  // eslint-disable-next-line no-underscore-dangle
  ...typeof window === 'undefined' ? {} : window.__NEXT_DATA__,
};

const withDefaultLocale = (locale) => locale || 'en-IE';

const getMessagesFileUrl = (locale) => `${
  assetPrefix || ''}/_next/static/lang/${
  withDefaultLocale(locale)}.json`;

const localeMessages = typeof window === 'undefined'
  ? {
    'bg-BG': addDefaultMessages(await loadMessages('bg-BG')),
    'cs-CZ': addDefaultMessages(await loadMessages('cs-CZ')),
    'da-DK': addDefaultMessages(await loadMessages('da-DK')),
    'de-AT': addDefaultMessages(await loadMessages('de-AT')),
    'de-CH': addDefaultMessages(await loadMessages('de-CH')),
    'de-DE': addDefaultMessages(await loadMessages('de-DE')),
    'el-CY': addDefaultMessages(await loadMessages('el-CY')),
    'el-GR': addDefaultMessages(await loadMessages('el-GR')),
    'en-AU': addDefaultMessages(await loadMessages('en-AU')),
    'en-CA': addDefaultMessages(await loadMessages('en-CA')),
    'en-GB': addDefaultMessages(await loadMessages('en-GB')),
    'en-IE': addDefaultMessages(await loadMessages('en-IE')),
    'en-IN': addDefaultMessages(await loadMessages('en-IN')),
    'en-NZ': addDefaultMessages(await loadMessages('en-NZ')),
    'en-US': addDefaultMessages(await loadMessages('en-US')),
    'es-AR': addDefaultMessages(await loadMessages('es-AR')),
    'es-CL': addDefaultMessages(await loadMessages('es-CL')),
    'es-CO': addDefaultMessages(await loadMessages('es-CO')),
    'es-ES': addDefaultMessages(await loadMessages('es-ES')),
    'es-MX': addDefaultMessages(await loadMessages('es-MX')),
    'es-PE': addDefaultMessages(await loadMessages('es-PE')),
    'et-EE': addDefaultMessages(await loadMessages('et-EE')),
    'fi-FI': addDefaultMessages(await loadMessages('fi-FI')),
    'fr-BE': addDefaultMessages(await loadMessages('fr-BE')),
    'fr-CA': addDefaultMessages(await loadMessages('fr-CA')),
    'fr-CH': addDefaultMessages(await loadMessages('fr-CH')),
    'fr-FR': addDefaultMessages(await loadMessages('fr-FR')),
    'fr-LU': addDefaultMessages(await loadMessages('fr-LU')),
    'hr-HR': addDefaultMessages(await loadMessages('hr-HR')),
    'hu-HU': addDefaultMessages(await loadMessages('hu-HU')),
    'it-CH': addDefaultMessages(await loadMessages('it-CH')),
    'it-IT': addDefaultMessages(await loadMessages('it-IT')),
    'ja-JP': addDefaultMessages(await loadMessages('ja-JP')),
    'lt-LT': addDefaultMessages(await loadMessages('lt-LT')),
    'lv-LV': addDefaultMessages(await loadMessages('lv-LV')),
    'mt-MT': addDefaultMessages(await loadMessages('mt-MT')),
    'nb-NO': addDefaultMessages(await loadMessages('nb-NO')),
    'nl-BE': addDefaultMessages(await loadMessages('nl-BE')),
    'nl-NL': addDefaultMessages(await loadMessages('nl-NL')),
    'pl-PL': addDefaultMessages(await loadMessages('pl-PL')),
    'pt-BR': addDefaultMessages(await loadMessages('pt-BR')),
    'pt-PT': addDefaultMessages(await loadMessages('pt-PT')),
    'ro-RO': addDefaultMessages(await loadMessages('ro-RO')),
    'ru-RU': addDefaultMessages(await loadMessages('ru-RU')),
    'sk-SK': addDefaultMessages(await loadMessages('sk-SK')),
    'sl-SI': addDefaultMessages(await loadMessages('sl-SI')),
    'sv-SE': addDefaultMessages(await loadMessages('sv-SE')),
    'tr-TR': addDefaultMessages(await loadMessages('tr-TR')),
    'zh-CN': addDefaultMessages(await loadMessages('zh-CN')),
    'zh-HK': addDefaultMessages(await loadMessages('zh-HK')),
  }
  : {
    // eslint-disable-next-line no-underscore-dangle
    [withDefaultLocale(window.__NEXT_DATA__.props.locale)]: addDefaultMessages(
      await (async () => {
        // eslint-disable-next-line @stylistic/max-len, no-underscore-dangle
        const response = await fetch(getMessagesFileUrl(window.__NEXT_DATA__.props.locale));

        return response.json();
      })(),
    ),
  };

const getMessages = (locale) => localeMessages[withDefaultLocale(locale)];

export {
  getMessages,
  getMessagesFileUrl,
};
